import Link from 'next/link'
import useTranslation from '@/hooks/useTranslation'

import NotificationBody from './NotificationBody'
import styles from './NotificationList.module.scss'

const NotificationList = ({ notifications }) => {
  const { t } = useTranslation()

  return (
    <div className='bg-white shadow-notification rounded-xl w-[370px] md:w-[22.25rem]'>
      {notifications && (
        <div
          className={`${styles.navNotificationBody} nav-notification-body max-h-[400px] md:max-h-[20rem] overflow-auto`}
        >
          <NotificationBody {...{ notifications }} />
        </div>
      )}

      {notifications?.length > 0 ? (
        <div className='p-10 text-center border-t border-[#e6ebf1]'>
          <Link
            href='/dashboard/notifications'
            className='text-green font-medium text-sm'
          >
            {t('View all')}
          </Link>
        </div>
      ) : null}
    </div>
  )
}

export default NotificationList
